// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._9vKQV9-xWQAEIesXDJK0oA\\=\\={display:flex;margin-left:-1.6rem;margin-right:-1.6rem;max-width:calc(60vw + 7.2rem);overflow-x:auto;padding:.3rem 1.6rem}._9vKQV9-xWQAEIesXDJK0oA\\=\\=::-webkit-scrollbar{display:none}.-uC4E4Cmstax6wUFwXrcWA\\=\\=.-uC4E4Cmstax6wUFwXrcWA\\=\\={flex-shrink:0;margin-right:2rem;width:60vw}@media (min-width:480px){._9vKQV9-xWQAEIesXDJK0oA\\=\\={box-shadow:none;flex-wrap:wrap;margin:0;max-width:100%;padding:0}.-uC4E4Cmstax6wUFwXrcWA\\=\\=.-uC4E4Cmstax6wUFwXrcWA\\=\\={width:calc(33.33333% - 1.33333rem)}.-uC4E4Cmstax6wUFwXrcWA\\=\\=:nth-child(3n+0){margin:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_9vKQV9-xWQAEIesXDJK0oA==",
	"characteristicBox": "-uC4E4Cmstax6wUFwXrcWA=="
};
module.exports = ___CSS_LOADER_EXPORT___;
